import { IS_SSR } from '../../constants/env';

export type OneTrustGroups = string | string[] | undefined;

export function getOneTrustActiveGroups(event?: Event): OneTrustGroups {
    const detail = (event as CustomEvent<string[]> | undefined)?.detail;

    if (Array.isArray(detail)) return detail;

    if (IS_SSR) return;

    return window.OnetrustActiveGroups ?? window.OptanonActiveGroups;
}
